"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var FundsSection = /** @class */ (function () {
    function FundsSection() {
    }
    FundsSection.prototype.onLoadEach = function ($element) {
        var $loadmoreWrap = $element.$(".FundsSection__loadmore");
        if (!$loadmoreWrap)
            return;
        var $loadmoreBtn = $loadmoreWrap.$(".cta");
        var $itemsWrap = $element.$(".FundsSection__items");
        var $hiddenItems = $itemsWrap.$$(".FundsSection__item.--hide");
        var loadmoreClick$ = (0, rxjs_1.fromEvent)($loadmoreBtn, "click").pipe((0, operators_1.takeUntil)(this.domRefresh$), (0, operators_1.take)(1));
        loadmoreClick$.subscribe(function () {
            $hiddenItems.forEach(function ($item) {
                $item.classList.remove("--hide");
                $item.classList.add("--animate");
            });
            $loadmoreWrap.remove();
        });
    };
    FundsSection = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".FundsSection__section",
            isElementArray: true
        })
    ], FundsSection);
    return FundsSection;
}());
new FundsSection();
